/* DENSA — header davranışları · v5.9 — 23 Ağu 2026
   v5.9: SEPET ONAY KUTUSU KALDIRILDI (kurucu kararı: onay kutusu sepette değil, kart bilgilerinin
   girildiği ÖDEME ADIMINDA olmalı). Shopify'ın hazır ödeme sayfasına kutu eklemek checkout-extension
   uygulaması gerektirir — araştırılıyor; o zamana dek yasal dayanak: sözleşme Madde 8 (sipariş onayı =
   kabul) + checkout altbilgisindeki politika bağlantıları. v5.7/v5.8 onay kodu bu sürümde YOK.
   v5.6: mega menü regresyon düzeltmesi — .densa-ipucu .menu-list bağlantılarına ASLA verilmez.
   v5.4: girişsiz hesap tıklaması kapı penceresi. v5.2/v5.1/v5.0/v4.x/v3: geçmiş notlar korunuyor. */
(function () {
  var header = document.getElementById('header-component');
  if (!header) return;
  function durum() {
    header.classList.toggle('densa-scrolled', window.scrollY > 160);
  }
  durum();
  window.addEventListener('scroll', durum, { passive: true });

  document.addEventListener('click', function (e) {
    if (window.densaMusteri) return;
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('#densaHesapKapiP')) return;
    var h = e.target.closest('.account-button, .account-popover, .account-actions, a[href="/account"], a[href^="/account?"], a[href*="customer_authentication"], a[href="/pages/hesap"]');
    if (!h) return;
    if (!header.contains(h) && !h.closest('.header__drawer')) return;
    e.preventDefault();
    e.stopPropagation();
    var kapi = document.getElementById('densaHesapKapiP');
    if (kapi && typeof kapi.showModal === 'function') {
      if (!kapi.open) { try { kapi.showModal(); } catch (err) { window.location.href = '/pages/hesap'; } }
      return;
    }
    window.location.href = '/pages/hesap';
  }, true);

  if (window.matchMedia && matchMedia('(hover: hover) and (min-width: 990px)').matches) {
    var sonX = 0, sonY = 0, bekci = null;
    function kayipHoverKontrol() {
      bekci = null;
      if (header.querySelector('[role=menuitem][aria-expanded=true]')) return;
      var hedef = document.elementFromPoint(sonX, sonY);
      if (!hedef || !hedef.closest) return;
      var oge = hedef.closest('.menu-list__list-item');
      if (!oge || !header.contains(oge) || !oge.querySelector('[ref^=submenu]')) return;
      try { oge.dispatchEvent(new PointerEvent('pointerenter')); } catch (e) {}
    }
    document.addEventListener('pointermove', function (e) {
      sonX = e.clientX; sonY = e.clientY;
      if (!bekci) bekci = setTimeout(kayipHoverKontrol, 60);
    }, { passive: true });
  }

  var PROTOKOL = {
    'antiaging-bakim-protokolu': 'İnce Çizgi · Kırışıklık · Sıkılık · Leke/Ton',
    'nem-bariyer-protokolu': 'Nem · Bariyer · Canlılık',
    'leke-ton-dengeleme-protokolu': 'Leke · Ton Eşitsizliği · Işıltı',
    'detoks-bakim-protokolu': 'Akneye Eğilimli · Siyah Nokta · Gözenek · Yağ Dengesi',
    'arindirma-protokolu': 'Temizleme · Arınma · Tazelik',
    'sac-bakim-protokolu': 'Güçlü · Parlak · Dengeli',
    'vucut-spa-protokolu': 'Masaj · Nem · Sıkılık · Günlük Vücut Bakımı'
  };
  var KESFET = {
    '/pages/felsefemiz-degerlerimiz': 'Felsefemiz, AromaBotanik kavramımız, değerlerimiz ve Densa\'yı özgün yapan incelikler bu sayfadadır.',
    '/pages/formulasyon-mimarimiz': 'Dört formül ailemizi ve hangi ürünün hangi aileden geldiğini anlatır.',
    '/pages/icerik-cografyamiz': 'Anadolu\'nun mirasından moleküler aktiflere, her hammaddenin kökenini ve araştırma notunu sunar.',
    '/pages/tasarimin-dili': 'Kutudaki motiften ambleme, renklerin ve yazının hikâyesini anlatır.',
    '/blogs/longevity-rituelleri': 'Ritüelin sırasına, mevsimine ve cilde göre kuruluşuna dair yazılar sunar.',
    '/pages/longevity-club': 'Üyelere özel fırsatlar ve puan sistemi çok yakında sizlerle buluşuyor.'
  };
  var KATMAP = {
    'Cilt Bakımı': ['/collections/cilt-bakim', 'Kategorideki Tüm Ürünleri Keşfedin'],
    'Saç Bakımı': ['/collections/sac-bakim', 'Kategorideki Tüm Ürünleri Keşfedin'],
    'Vücut & SPA': ['/collections/vucut-spa-bakim', 'Kategorideki Tüm Ürünleri Keşfedin'],
    'Tüm Ürünler': ['/collections/all', 'Tüm Ürünleri Keşfedin']
  };
  function stil() {
    if (document.getElementById('densa-prot-stil')) return;
    var s = document.createElement('style');
    s.id = 'densa-prot-stil';
    s.textContent =
      '.densa-prot{display:flex !important;flex-direction:column;align-items:flex-start;border-left:1px solid rgba(174,159,125,.7);padding-left:10px;margin:6px 0;line-height:1.25;}' +
      '.densa-prot .densa-prot-ad{font-weight:600;}' +
      '.densa-prot .densa-prot-alt{display:block;font-weight:400;font-size:.78em;letter-spacing:.04em;color:#4F635A;margin-top:3px;white-space:normal;}' +
      '.menu-drawer__menu-item-text.densa-prot{margin:2px 0;}' +
      '.densa-mega__link.densa-prot{margin:14px 0;}' +
      '.header__drawer .menu-drawer__menu-item-text{text-transform:none;}' +
      '.header__drawer .menu-drawer__menu-item--mainlist .menu-drawer__menu-item-text{font-size:24px;}' +
      '.densa-drawer-kat{display:inline-block;font-size:11px;letter-spacing:.16em;text-transform:uppercase;color:#AE9F7D;font-weight:600;text-decoration:underline;text-underline-offset:4px;margin:6px 0 12px;}' +
      '.densa-oklu{display:flex !important;align-items:center;justify-content:space-between;gap:12px;}' +
      '.densa-chev{display:inline-flex;color:#124034;opacity:.85;flex:0 0 auto;}' +
      '.densa-drawer-alt{margin:28px 0 8px;padding:18px 0 0 10px;border-top:1px solid rgba(174,159,125,.45);display:flex;flex-direction:column;gap:2px;}' +
      '.densa-drawer-alt a{display:flex;align-items:center;gap:12px;font-size:15px;letter-spacing:.02em;color:#124034;text-decoration:none;padding:9px 0;}' +
      '.densa-drawer-alt a svg{width:19px;height:19px;flex:0 0 auto;color:#AE9F7D;}';
    (document.head || document.documentElement).appendChild(s);
  }
  function protokolAnahtari(href) {
    try { var m = (href || '').match(/\/collections\/([a-z0-9-]+)/i); return m ? m[1].toLowerCase() : ''; } catch (e) { return ''; }
  }
  function yol(href) {
    try { return new URL(href, location.origin).pathname.replace(/\/+$/, '').toLowerCase(); } catch (e) { return (href || '').split('?')[0]; }
  }
  function isle(el, altMetin) {
    if (!el || el.getAttribute('data-dprot')) return;
    if (!altMetin) return;
    var ad = (el.textContent || '').trim();
    if (!ad) return;
    el.setAttribute('data-dprot', '1');
    el.classList.add('densa-prot');
    el.textContent = '';
    var b = document.createElement('span'); b.className = 'densa-prot-ad'; b.textContent = ad;
    var k = document.createElement('span'); k.className = 'densa-prot-alt'; k.textContent = altMetin;
    el.appendChild(b); el.appendChild(k);
  }
  var SVG = {
    kalp: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
    ahize: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(12 12) scale(0.82) translate(-12 -12)"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z"/></g></svg>',
    kisi: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8.2" r="3.6"/><path d="M5.2 19.6a6.9 6.9 0 0 1 13.6 0"/></svg>',
    belge: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3.8h8.2L18 7.6V20a.8.8 0 0 1-.8.8H6a.8.8 0 0 1-.8-.8V4.6c0-.4.4-.8.8-.8Z"/><path d="M14 3.8v4h4"/><path d="M8.5 12h5M8.5 15h3"/></svg>',
    ok: '<svg viewBox="0 0 10 14" width="9" height="13" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M2 1.5 7.5 7 2 12.5"/></svg>'
  };
  function cekmeceEk() {
    try {
      var dr = document.querySelector('.header__drawer');
      if (!dr) return;
      Array.prototype.forEach.call(dr.querySelectorAll('details'), function (d) {
        if (d.getAttribute('data-dkat')) return;
        var sm = null;
        for (var i = 0; i < d.children.length; i++) { if (d.children[i].tagName === 'SUMMARY') { sm = d.children[i]; break; } }
        if (!sm) return;
        var ad = (sm.textContent || '').trim();
        var m = KATMAP[ad];
        if (!m) return;
        var icerik = null;
        for (var j = 0; j < d.children.length; j++) { if (d.children[j].tagName !== 'SUMMARY') { icerik = d.children[j]; break; } }
        if (!icerik) return;
        d.setAttribute('data-dkat', '1');
        var hedef = icerik.querySelector('ul') || icerik;
        var a = document.createElement('a');
        a.className = 'densa-drawer-kat';
        a.href = m[0];
        a.textContent = m[1];
        if (hedef.tagName === 'UL') { var li = document.createElement('li'); li.appendChild(a); hedef.insertBefore(li, hedef.firstChild); }
        else { hedef.insertBefore(a, hedef.firstChild); }
      });
      Array.prototype.forEach.call(dr.querySelectorAll('a[href*=en-sevilenler], a[href*=longevity-club]'), function (a) {
        if (a.querySelector('.densa-chev')) return;
        var s = document.createElement('span'); s.className = 'densa-chev'; s.innerHTML = SVG.ok;
        a.classList.add('densa-oklu'); a.appendChild(s);
      });
      var kok = dr.querySelector('.menu-drawer');
      if (kok && !kok.querySelector('.densa-drawer-alt')) {
        var b = document.createElement('div');
        b.className = 'densa-drawer-alt';
        var hesapYolu = window.densaMusteri ? '/account' : '/pages/hesap';
        [['/pages/istek-listesi', 'İstek Listem', SVG.kalp], ['/pages/iletisim', 'Bize Ulaşın', SVG.ahize], [hesapYolu, 'Hesabım', SVG.kisi], ['/pages/kurumsal', 'Kurumsal', SVG.belge]].forEach(function (r) {
          var a = document.createElement('a');
          a.href = r[0];
          a.innerHTML = r[2] + '<span>' + r[1] + '</span>';
          b.appendChild(a);
        });
        kok.appendChild(b);
      }
    } catch (e) {}
  }
  function tara() {
    try {
      stil();
      Array.prototype.forEach.call(document.querySelectorAll('a.densa-mega__link'), function (a) {
        isle(a, PROTOKOL[protokolAnahtari(a.getAttribute('href'))]);
      });
      Array.prototype.forEach.call(document.querySelectorAll('.menu-drawer__menu-item-text'), function (sp) {
        var a = sp.closest('a'); if (!a) return;
        var href = a.getAttribute('href');
        isle(sp, PROTOKOL[protokolAnahtari(href)] || KESFET[yol(href)]);
      });
      cekmeceEk();
    } catch (e) {}
  }

  function ipucuStil() {
    if (document.getElementById('densa-ipucu-stil')) return;
    var s = document.createElement('style');
    s.id = 'densa-ipucu-stil';
    s.textContent =
      '@media (hover:hover) and (min-width:990px){' +
      '.densa-ipucu{position:relative;overflow:visible !important;}' +
      '.densa-ipucu::after{content:attr(data-ipucu);position:absolute;top:calc(100% + 2px);left:50%;transform:translate(-50%,4px);' +
      'background:#F4EFE4;color:#124034;border:1px solid rgba(174,159,125,.75);font-family:var(--sans,DENSA Sans,sans-serif);' +
      'font-size:10px;font-weight:600;line-height:1;letter-spacing:.14em;text-transform:uppercase;padding:6px 9px;white-space:nowrap;' +
      'opacity:0;pointer-events:none;transition:opacity .18s ease,transform .18s ease;z-index:6;box-shadow:0 4px 14px rgba(10,32,25,.08);}' +
      '.densa-ipucu:hover::after,.densa-ipucu:focus-visible::after{opacity:1;transform:translate(-50%,0);}' +
      '}';
    (document.head || document.documentElement).appendChild(s);
  }
  function ipucuVer(el, metin) {
    if (!el || el.classList.contains('densa-ipucu')) return;
    if (el.closest && el.closest('.menu-list')) return;
    el.classList.add('densa-ipucu');
    if (!el.getAttribute('data-ipucu')) el.setAttribute('data-ipucu', metin);
  }
  function ipucular() {
    try {
      ipucuStil();
      var kok = header;
      var ara = kok.querySelector('.search-action button, .search-action a, button[aria-label*=Ara i], a[href*=search]');
      if (ara) ipucuVer(ara, 'Arama');
      var hesap = kok.querySelector('.account-popover > summary, .account-popover summary, a[href*=account], [ref=accountButton], .account-actions > *');
      if (hesap) ipucuVer(hesap, 'Hesabım');
      Array.prototype.forEach.call(kok.querySelectorAll('.densa-hd-ek'), function (a) { ipucuVer(a, a.getAttribute('data-ipucu') || ''); });
      var sepet = kok.querySelector('.header-actions__cart-icon, cart-icon, .action__cart');
      if (sepet) { var hedef = sepet.closest('a,button,summary') || sepet; ipucuVer(hedef, 'Sepetim'); }
    } catch (e) {}
  }
  ipucular();
  document.addEventListener('DOMContentLoaded', ipucular);
  setTimeout(ipucular, 900);

  tara();
  document.addEventListener('DOMContentLoaded', tara);
  setTimeout(tara, 800);
  try {
    var bekle = null;
    new MutationObserver(function () { if (bekle) return; bekle = setTimeout(function () { bekle = null; tara(); }, 150); })
      .observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
